export default "__VITE_ASSET__9f90712b__"